<template>
  <el-select v-model="deliveryAddressId"
    @change="handleChange"
    filterable
    remote
    clearable
    placeholder="请输入收货方名称"
    :remote-method="remoteMethod"
    :loading="loading">
    <el-option v-for="item in options"
      :key="item.deliveryAddressId"
      :label="item.deliveryNameFull"
      :value="item.deliveryAddressId">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'ent-delivery-auto-select',
  components: {},
  props: {
    value: {
      // type: [Number, null],
      required: true
    },
    callback: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      options: []
    }
  },
  watch: {},
  computed: {
    deliveryAddressId: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange () {
      this.callback && this.callback()
    },
    remoteMethod (query) {
      if (query) {
        this.loading = true
        this.$store.dispatch('delivery/getdeliveryaddresses', {
          payload: {
            pageNum: 1,
            pageSize: 100,
            deliveryName: query,
            vendorId: null
          },
          success: (res) => {
            this.loading = false
            this.options = res.data.records.map(i => {
              return {
                ...i,
                deliveryNameFull: i.deliveryName + `【${i.deliveryPhone}】`
              }
            })
          },
          fail: () => {
            this.loading = false
            this.options = []
          }
        })
      } else {
        this.options = []
      }
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus" scoped></style>
